import React, { useEffect, useState } from 'react';
import { Form, Grid, Checkbox, Button } from 'semantic-ui-react';
import { FemaGoModal, FemaGoTable } from 'app-ui-componentlibrary';

const ManageGroupForm = ({
  loading,
  groups,
  selectedGroup,
  manageModalVisible,
  categories,
  openManageTeamModal,
  updateSelectedGroup,
  closeManageTeamModal,
  selectAllCategories,
  handleSelectCategory,
  handleChangeStatus,
  modalType
}) => {
  const [checkAll, setCheckAll] = useState(false)
  const [initialCheckStatus, setInitialCheckStatus] = useState(false)
  const [suspended, setSuspended] = useState(false)

  useEffect(() => {
    setSuspended(selectedGroup.suspended ?? false)
    setInitialCheckStatus(selectedGroup.suspended)
  }, [selectedGroup])

  const resetFormSelection = () => {
    categories.map((category) => {
      delete category['checked']
    })
  }

  const checkForSelected = () => {
    const checkChecked = categories.some((category) => {
      return category.checked === true
    })

    return checkChecked ? false : true
  }

  return (
    <React.Fragment>
      <FemaGoModal
        title={'Manage this group'}
        open={manageModalVisible && modalType === 'manage'}
        size='small'
        buttonText="Save & close"
        confirmButton="hidden"
        closeOnDimmerClick='no'
        confirmAction={() => { updateSelectedGroup(selectedGroup, suspended); openManageTeamModal(selectedGroup) }}
        cancelAction={() => {
          resetFormSelection();
          setSuspended(initialCheckStatus);
          openManageTeamModal(selectedGroup);
          setCheckAll(false);
        }}
      >
        {!loading && selectedGroup != undefined ? (
          <Form>
            <Grid celled>
              <Grid.Row>
                <Grid.Column width={8}>
                  <small>
                    <strong>Group name: </strong>
                  </small>
                  <br />
                  <strong>{selectedGroup.name}</strong>
                </Grid.Column>
                <Grid.Column width={8}>
                  <small>
                    <strong>Status:</strong>
                  </small>
                  <br />
                  <Checkbox
                    // type='toggle'
                    label={!suspended ? 'Active' : 'Inactive'}
                    checked={!suspended}
                    onChange={() => setSuspended(!suspended)}
                    disabled={!selectedGroup.suspended || (selectedGroup.reviewers && selectedGroup.reviewers.length > 2) ? false : true}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <div className="container_femagotable" >
                    <div className="sidescroll">
                      <FemaGoTable scrollable={10}>

                        <FemaGoTable.Header>
                          <FemaGoTable.Row>
                            <FemaGoTable.HeaderCell>
                              <input
                                id="selectAll"
                                name="selectAll"
                                title="select/deselect all"
                                type="checkbox"
                                onClick={() => { selectAllCategories(categories, !checkAll); setCheckAll(!checkAll) }}
                              />
                              &nbsp;
                              <label htmlFor="selectAll">Select all</label>
                            </FemaGoTable.HeaderCell>
                            <FemaGoTable.HeaderCell width={'twelve'}>
                              Categories
                            </FemaGoTable.HeaderCell>
                          </FemaGoTable.Row>
                        </FemaGoTable.Header>
                        <FemaGoTable.Body>
                          {categories &&
                            _.map(categories, (category, index) => {
                              return (<FemaGoTable.Row key={index}>
                                <FemaGoTable.TextCell textAlign="left">
                                  <input
                                    type="checkbox"
                                    name={'category_' + index}
                                    value={index}
                                    checked={category && category.checked}
                                    onChange={() => handleSelectCategory(category)}
                                  />
                                </FemaGoTable.TextCell>
                                <FemaGoTable.TextCell width={'twelve'}>
                                  {category?.name}
                                </FemaGoTable.TextCell>
                              </FemaGoTable.Row>
                              );
                            })}
                        </FemaGoTable.Body>
                      </FemaGoTable>
                    </div>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <div style={{ marginTop: '50px' }}>

            </div>
            <Button
              id='save'
              primary
              compact
              disabled={checkForSelected()}
              onClick={() => { handleChangeStatus(selectedGroup, suspended); updateSelectedGroup(selectedGroup, suspended); openManageTeamModal(selectedGroup) }}
            >Save </Button>
          </Form>
        ) : (
          <div>Loading entities</div>
        )}
      </FemaGoModal>
    </React.Fragment>
  )
}

export default ManageGroupForm;